import React, { useContext, useMemo } from 'react';
import { PracticeTypesPerInstitution } from './calendarModels';
import CalendarPerInstution from './calendarPerInstitution';
import { PraksiskalenderAktivitetDto } from '../api/generated/studiested-generated-api';
import { Language, LanguageContext, toLocaleTag } from '../i18n/LanguageStore';
import { sortNotInPlace } from '../util/sort';

interface Props {
  practiceTypesFiltered: PracticeTypesPerInstitution[];
  practicePeriodsFiltered: {
    [klasseId: string]: PraksiskalenderAktivitetDto[];
  };
  onActivityStatusFilterChanged: Function;
  checkIfGroupCanBeSafelyDeleted: (klasseId: string) => boolean;
}

const sortPracticeTypes = (
  practiceTypes: PracticeTypesPerInstitution[],
  selectedLanguage: Language,
): PracticeTypesPerInstitution[] =>
  sortNotInPlace(practiceTypes, (a, b) =>
    a.institutionNames
      .join('-')
      .localeCompare(
        b.institutionNames.join('-'),
        toLocaleTag(selectedLanguage),
      ),
  );

const Calendars: React.FC<React.PropsWithChildren<Props>> = ({
  practiceTypesFiltered,
  practicePeriodsFiltered,
  onActivityStatusFilterChanged,
  checkIfGroupCanBeSafelyDeleted,
}) => {
  const { selectedLanguage } = useContext(LanguageContext);

  const sortedPracticeTypes = useMemo(
    () => sortPracticeTypes(practiceTypesFiltered, selectedLanguage),
    [practiceTypesFiltered, selectedLanguage],
  );

  return (
    <>
      {sortedPracticeTypes.map((it: PracticeTypesPerInstitution, i) => (
        <CalendarPerInstution
          orderNo={i}
          key={it.institutionCodesSlug}
          institutionCodesSlug={it.institutionCodesSlug}
          practiceTypes={it}
          practicePeriodsFiltered={practicePeriodsFiltered}
          onActivityStatusFilterChanged={onActivityStatusFilterChanged}
          checkIfGroupCanBeSafelyDeleted={checkIfGroupCanBeSafelyDeleted}
        />
      ))}
    </>
  );
};

export default Calendars;
